import { Link } from "react-router-dom";

export default function SiteIntro() {
  return (
    <section className="mx-auto w-full max-w-[1400px] px-4 pt-14 md:px-8 md:pt-20">
      <div className="overflow-hidden rounded-lg border border-background-800 bg-background-900">
        <div className="grid grid-cols-1 lg:grid-cols-[1.4fr_1fr]">
          <div className="p-6 md:p-10">
            <span className="inline-flex items-center gap-2 rounded-md bg-accent-500/15 px-3 py-1 text-xs text-accent-400">
              <i className="ri-information-line" />
              关于本站
            </span>
            <h2 className="mt-4 font-heading text-xl font-bold text-foreground-50 md:text-2xl">
              欧美精品在线观看 · 专业影视资料与推荐平台
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-300 md:text-base">
              我们专注整理与推荐高品质的欧美电影和电视剧，从近年新作到历久弥新的经典，
              通过清晰的分类、多维度筛选与真实可查的影片资料，帮助观众更快找到想看的内容。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-400">
              本站为影视资讯与推荐展示平台，播放区域仅用于界面演示，不提供实际视频流媒体服务。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to="/about"
                className="rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-foreground-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
              >
                了解我们
              </Link>
              <Link
                to="/category"
                className="rounded-md border border-background-700 px-5 py-2.5 text-sm text-foreground-200 transition-colors hover:border-accent-500 hover:text-accent-400 whitespace-nowrap cursor-pointer"
              >
                浏览全部影片
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-3 border-t border-background-800 lg:grid-cols-1 lg:border-l lg:border-t-0">
            {[
              { value: "40+", label: "精选影视" },
              { value: "20+", label: "影片类型" },
              { value: "4", label: "主题专题" },
            ].map((stat, i) => (
              <div
                key={stat.label}
                className={`flex flex-col items-center justify-center px-4 py-6 lg:py-0 ${
                  i !== 0 ? "border-l border-background-800 lg:border-l-0 lg:border-t" : ""
                }`}
              >
                <span className="font-heading text-2xl font-bold text-accent-400 md:text-3xl">
                  {stat.value}
                </span>
                <span className="mt-1 text-xs text-foreground-400">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}